import { STORAGE_KEYS } from '../types';

/** Extra keys not yet centralized in STORAGE_KEYS */
const ADDITIONAL_LOCAL_KEYS = [
  'NIMAH_ACCOUNT_CONFIGS',
  'NIMAH_TOOLS_QUERY_CACHE',
] as const;

const SESSION_KEY_PREFIXES = ['nimah_actual_bootstrap_password_'] as const;

/**
 * Clears browser storage that is tied to a signed-in user's session /
 * onboarding so the next account starts from a clean slate.
 * Keeps preferences that are not user-specific (e.g. i18n language).
 */
export function clearUserExperienceStorage(): void {
  try {
    Object.values(STORAGE_KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });

    ADDITIONAL_LOCAL_KEYS.forEach((key) => {
      localStorage.removeItem(key);
    });

    const sessionKeysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && SESSION_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        sessionKeysToRemove.push(key);
      }
    }
    sessionKeysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    console.error('Failed to clear user experience storage:', error);
  }
}
